module.exports = __webpack_public_path__ + "static/media/pdi-image-08.248328ee.svg";